import { useHistory } from 'react-router-dom';
import { routes } from "../../../constants";
import { useStoreActions } from "../../../contexts.ts";
import { useMutationState } from "../../../hooks/reactQuery/useMutationState";
export const useCreateDraft = _ref => {
  let {
    onSuccess: _onSuccess
  } = _ref;
  const {
    api
  } = useStoreActions();
  const history = useHistory();
  const {
    mutate,
    isPending
  } = useMutationState({
    mutationFn: async templateId => {
      return await api.proposalTemplates.createDraft(templateId);
    },
    onSuccess: draftId => {
      history.push(routes.draft(draftId));
      _onSuccess === null || _onSuccess === void 0 || _onSuccess();
    }
  });
  return {
    createDraft: mutate,
    isInProgress: isPending
  };
};